
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lumgz", function(module, exports) {

$parcel$export(module.exports, "spaceForBaseSpaceQuery", () => $0b6a8bfd3c8020a4$export$10cb56c00ac59a8a);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $0b6a8bfd3c8020a4$export$10cb56c00ac59a8a = (0, $d2LG0.default)`query spaceForBaseSpaceQuery($spaceKey:String){spaces(spaceKey:$spaceKey){nodes{id key alias name homepage{id}icon{path width height isDefault}type settings{routeOverrideEnabled}theme{themeKey}lookAndFeel{headings{key value}menus{hoverOrFocus{key value}color}header{backgroundColor button{backgroundColor color}primaryNavigation{color hoverOrFocus{key value}}secondaryNavigation{color hoverOrFocus{key value}}search{backgroundColor color}}content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode layer{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode width height}gutterTop gutterRight gutterBottom gutterLeft}container{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}header{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}body{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}}}metadata{labels{nodes{prefix name id}}}operations{operation targetType}}}}`;

});

parcelRegister("iqPBi", function(module, exports) {

$parcel$export(module.exports, "SpaceBase", () => $023f02fd9a9aead0$export$adbf61121b32bd9b);
/**
 * @graphql cc
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4y1GY = parcelRequire("4y1GY");

var $6qIXK = parcelRequire("6qIXK");

var $inPa6 = parcelRequire("inPa6");

var $dPJCf = parcelRequire("dPJCf");

var $1ytiN = parcelRequire("1ytiN");

var $fM6x5 = parcelRequire("fM6x5");

var $9wGTI = parcelRequire("9wGTI");

var $cEgMD = parcelRequire("cEgMD");

var $8oCjN = parcelRequire("8oCjN");

var $4b4iP = parcelRequire("4b4iP");

var $j9XVO = parcelRequire("j9XVO");
const $023f02fd9a9aead0$var$DISPLAY_ROOT = 'display';
const $023f02fd9a9aead0$var$SPACE_ROOT = 'spaces';
const $023f02fd9a9aead0$var$getUrlRoot = (pathname)=>{
    if (!pathname) return undefined;
    if (pathname.includes(`/${$023f02fd9a9aead0$var$SPACE_ROOT}/`)) return $023f02fd9a9aead0$var$SPACE_ROOT;
    else if (pathname.includes(`/${$023f02fd9a9aead0$var$DISPLAY_ROOT}/`)) return $023f02fd9a9aead0$var$DISPLAY_ROOT;
    else return undefined;
};
const $023f02fd9a9aead0$var$useContentSlug = (0, $dPJCf.createRouteParamHook)('contentSlug');
const $023f02fd9a9aead0$var$useContentId = (0, $dPJCf.createRouteParamHook)('contentId');
const $023f02fd9a9aead0$var$LegacySpaceBaseComponent = ({ children: children, spaceKey: spaceKey, space: space, isSpaceLoading: isSpaceLoading })=>{
    const contentId = $023f02fd9a9aead0$var$useContentId();
    const contentSlug = $023f02fd9a9aead0$var$useContentSlug();
    const isViewPage = !!contentId || !!contentSlug;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isAnonymous: isAnonymous } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const history = (0, $dPJCf.useHistory)();
    const isFirstRoute = history?.length === 1;
    const location = (0, $4y1GY.useLocation)();
    const fixSpaceEncodingInSpaceKey = ()=>{
        const pathname = location?.pathname || '';
        const decodedPathname = decodeURIComponent(pathname);
        if (// excludes the cases where there are no + symbols to replace at all
        // eg: /spaces/perfectly-fine-space-key
        pathname.indexOf('+') !== -1 && // excludes the cases where there is a + that follows the space key portion of the path
        // eg: /spaces/DS/other+stuff+that+contains+plus
        spaceKey.indexOf('+') !== -1 && // excludes the cases where the decoded path name still contains a + (from %2B)
        // , but the replacement to strip the + from the space key has already happened in previous SPA transition
        // eg: pathname = '/spaces/space%2Bkey', decodedPathname = '/spaces/space+key', spaceKey = 'space+key'
        decodedPathname.indexOf(`spaces/${spaceKey}`) !== -1) history?.replace?.({
            ...location,
            // Ensure we are replacing the "+" in the space key not other funny stuff
            pathname: decodedPathname.replace(`spaces/${spaceKey}`, `spaces/${spaceKey}`.replace(/\+/g, ' '))
        });
    };
    const removeEmailQueryParameters = ()=>{
        if (!location?.search?.includes('src=mail') && !location?.search?.includes('src.mail.')) return;
        let search = location?.search?.substring(1);
        const params = search.split('&').filter((param)=>!param.includes('src=mail') && !param.startsWith('src.mail.'));
        search = `?${params.join('&')}`;
        history?.replace?.({
            ...location,
            search: search
        });
    };
    (0, $gwFzn.useEffect)(()=>{
        fixSpaceEncodingInSpaceKey();
        removeEmailQueryParameters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        spaceKey
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isSpaceLoading) return;
        if (space && space.alias && space.alias !== spaceKey) {
            const pathnameRoot = $023f02fd9a9aead0$var$getUrlRoot(location?.pathname);
            if (pathnameRoot) {
                const routeName = routeDataRef.current?.routeName || null;
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'redirect',
                        actionSubject: 'route',
                        source: 'SpaceBase',
                        attributes: {
                            routeName: routeName,
                            // Space key related attributes.
                            areSpaceKeysEqualLowercase: space?.alias?.toLowerCase() === spaceKey?.toLowerCase()
                        }
                    }
                }).fire();
                history?.replace?.({
                    ...location,
                    pathname: location?.pathname?.replace(`/${pathnameRoot}/${spaceKey}`, `/${pathnameRoot}/${space.alias}`)
                });
            }
            return;
        }
    }, [
        createAnalyticsEvent,
        history,
        location,
        space,
        spaceKey,
        routeDataRef,
        isSpaceLoading
    ]);
    /*
   * Removing SpaceBaseThemedComponent for the Company Hub app-like experience at Team '25 US
   *
   * @see {@link https://www.figma.com/design/MBdUXhdmgbsIkMkOhQGu5e/Hub-App?node-id=101-52260}
   * @see {@link https://hello.atlassian.net/wiki/spaces/CLI/pages/4856024337/Confluence-less+Team+25+US+Experience}
   */ const SpaceBaseWrapper = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) && (0, $9wGTI.fg)('company-hub-pseudo-app') ? (0, $gwFzn.Fragment) : (0, $8oCjN.SpaceBaseThemedComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4b4iP.SpaceRestrictionHandler), {
        spaceKey: spaceKey,
        isAnonymous: isAnonymous,
        contentId: contentId,
        isFirstRoute: isFirstRoute,
        goBackPreviousPage: history?.goBack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "space-base-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6qIXK)))({
            'wrapper-space-view-page': isViewPage,
            'wrapper-space-home-page': !isViewPage
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(SpaceBaseWrapper, null, children)));
};
const $023f02fd9a9aead0$var$SpaceBaseComponent = ({ children: children, spaceKey: spaceKey, space: space, isSpaceLoading: isSpaceLoading })=>{
    const contentId = $023f02fd9a9aead0$var$useContentId();
    const contentSlug = $023f02fd9a9aead0$var$useContentSlug();
    const isViewPage = !!contentId || !!contentSlug;
    return $023f02fd9a9aead0$var$LegacySpaceBaseComponent({
        children: children,
        spaceKey: spaceKey,
        space: space,
        isSpaceLoading: isSpaceLoading
    });
};
const $023f02fd9a9aead0$var$useSpaceKey = (0, $dPJCf.createRouteParamHook)('spaceKey');
const $023f02fd9a9aead0$export$adbf61121b32bd9b = ({ children: children, spaceKey: spaceKey })=>{
    const resolvedSpaceKey = $023f02fd9a9aead0$var$useSpaceKey() || spaceKey || '';
    const { space: space, loading: loading } = (0, $j9XVO.useSpaceBaseQuery)({
        resolvedSpaceKey: resolvedSpaceKey
    });
    return (0, $fM6x5.default)(()=>space?.name)($023f02fd9a9aead0$var$SpaceBaseComponent)({
        spaceKey: resolvedSpaceKey,
        space: space,
        children: children,
        isSpaceLoading: loading
    });
};

});
parcelRegister("fM6x5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6436abe84fc91b7d$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $8EsbU = parcelRequire("8EsbU");

var $d5RCH = parcelRequire("d5RCH");
function $6436abe84fc91b7d$export$2e2bcd8739ae039(getTitle, wrapperStyle) {
    if (typeof wrapperStyle === 'undefined') wrapperStyle = {};
    return (BaseComponent)=>(props)=>{
            const title = getTitle(props);
            const siteTitle = (0, $8EsbU.getOverride)('site-title') || '';
            const titleDefinedOnWindow = window['__DOCUMENT_TITLE_TAG__'] || '';
            let titleProp;
            if (titleDefinedOnWindow) titleProp = titleDefinedOnWindow;
            else if (title && siteTitle) titleProp = `${title} - ${siteTitle}`;
            else titleProp = title || siteTitle;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
                style: wrapperStyle,
                "data-testid": "with-document-title"
            }, !window['__SSR_RENDERED__'] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d5RCH.PageTitle), {
                title: titleProp
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(BaseComponent, props)));
        };
}

});

parcelRegister("8oCjN", function(module, exports) {

$parcel$export(module.exports, "SpaceBaseThemedComponent", () => $7bbee5da9ba28ec8$export$7f576b861c4a75d4);

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $lKNXy = parcelRequire("lKNXy");

var $lpxTx = parcelRequire("lpxTx");
var $61vTv = parcelRequire("61vTv");

var $7zgzO = parcelRequire("7zgzO");

var $ep3mz = parcelRequire("ep3mz");

var $1NBp8 = parcelRequire("1NBp8");

var $3Klda = parcelRequire("3Klda");

var $5ZqQS = parcelRequire("5ZqQS");

var $7Sm4c = parcelRequire("7Sm4c");

var $dIouf = parcelRequire("dIouf");

var $fyPYm = parcelRequire("fyPYm");

var $kmaxw = parcelRequire("kmaxw");
const $7bbee5da9ba28ec8$var$connectAddonContainerStyle = {
    position: 'relative'
};
const $7bbee5da9ba28ec8$var$connectAddonProps = {
    contentStyle: {
        width: '100%',
        textAlign: 'center',
        display: 'inline-block'
    },
    width: '100%',
    height: '100%'
};
const $7bbee5da9ba28ec8$var$SPACE_THEME_KEY_MODULE_KEY_REGEX = /^ac:(.*)__(.*)-remote-theme$/;
const $7bbee5da9ba28ec8$export$3d1ab4d62a569dc7 = (themeKey)=>{
    const regexResult = $7bbee5da9ba28ec8$var$SPACE_THEME_KEY_MODULE_KEY_REGEX.exec(themeKey);
    return regexResult ? [
        regexResult[1],
        regexResult[2]
    ] : [
        null,
        null
    ];
};
const $7bbee5da9ba28ec8$export$7f576b861c4a75d4 = ({ children: children })=>{
    const { match: match } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const [{ contentIdLoading: contentIdLoading }] = (0, $ep3mz.usePageState)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentType] = (0, $ep3mz.useContentType)();
    let chooseContentUnifiedQuery = (0, $61vTv.ContentUnifiedQuery);
    if (contentType === 'blogpost') chooseContentUnifiedQuery = (0, $lpxTx.ContentBlogUnifiedQuery);
    const isSpaceOverview = match?.name === (0, $1NBp8.SPACE_OVERVIEW).name;
    const skipContentQuery = !contentId || !spaceKey || !isSpaceOverview || contentIdLoading;
    const contentQueryResult = (0, $diswb.useQuery)(chooseContentUnifiedQuery, {
        context: {
            single: true
        },
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: null,
            useNewContentTopper: true
        },
        skip: skipContentQuery
    });
    const themeKey = contentQueryResult?.data?.space?.theme?.themeKey;
    const routeOverrideEnabled = contentQueryResult?.data?.space?.settings?.routeOverrideEnabled;
    const [themeAddonKey, themeModuleKey] = $7bbee5da9ba28ec8$export$3d1ab4d62a569dc7(themeKey);
    const skipOverrideQuery = !themeAddonKey || !themeModuleKey || !routeOverrideEnabled;
    const overrideQueryResult = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Experimental Schema GraphQL Operation
    (0, $kmaxw.ExperimentalThemeSpaceHomeOverrideQuery), {
        variables: {
            themeAddonKey: themeAddonKey,
            themeModuleKey: themeModuleKey,
            spaceKey: spaceKey,
            spaceHomePageId: contentId
        },
        skip: skipOverrideQuery
    });
    if (contentQueryResult.error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(contentQueryResult.error, {
            attribution: (0, $dIouf.Attribution).ECOSYSTEM
        });
        (0, $7Sm4c.markErrorAsHandled)(contentQueryResult.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children);
    }
    if (overrideQueryResult.error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(overrideQueryResult.error, {
            attribution: (0, $dIouf.Attribution).ECOSYSTEM
        });
        (0, $7Sm4c.markErrorAsHandled)(overrideQueryResult.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children);
    }
    if (contentIdLoading) return null;
    if (skipContentQuery) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children);
    if (contentQueryResult.loading || !skipOverrideQuery && overrideQueryResult.loading) return null;
    if (skipOverrideQuery) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children);
    if (!contentQueryResult.data || !overrideQueryResult.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children);
    const { hasSpaceHomeOverride: hasSpaceHomeOverride, spaceHomeOverrideDescriptor: spaceHomeOverrideDescriptor } = overrideQueryResult.data.experimentalThemeSpaceHomeOverride;
    if (!hasSpaceHomeOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children);
    spaceHomeOverrideDescriptor.productContext = JSON.parse(spaceHomeOverrideDescriptor.productCtx);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3Klda.ContentScreenBackgroundLayer), {
        lookAndFeel: contentQueryResult?.data?.space?.lookAndFeel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lKNXy.ConnectAddon), {
        containerStyle: $7bbee5da9ba28ec8$var$connectAddonContainerStyle,
        descriptor: spaceHomeOverrideDescriptor,
        ...$7bbee5da9ba28ec8$var$connectAddonProps
    }), isSpaceOverview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fyPYm.ContentViewedEvent), {
        contentId: contentId
    }));
};

});
parcelRegister("lKNXy", function(module, exports) {

$parcel$export(module.exports, "ConnectAddon", () => $d2cf06290ddd4b8d$export$1679e39403bb0c0c);

var $jmjWc = parcelRequire("jmjWc");

const $d2cf06290ddd4b8d$export$1679e39403bb0c0c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rJ3Sr",
    loader: async ()=>(await (parcelRequire("acunF"))).ConnectAddon,
    name: 'ConnectAddonNext'
});

});
parcelRegister("acunF", function(module, exports) {

let $76d297590b574a53$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $76d297590b574a53$var$load("jXIn9"),
    $76d297590b574a53$var$load("6d83I")
]).then(()=>parcelRequire('2uezU'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});




parcelRegister("kmaxw", function(module, exports) {

$parcel$export(module.exports, "ExperimentalThemeSpaceHomeOverrideQuery", () => $301cd5cfa500762a$export$d9b1e55f2ab777a5);

var $d2LG0 = parcelRequire("d2LG0");
const $301cd5cfa500762a$export$d9b1e55f2ab777a5 = (0, $d2LG0.default)`query ExperimentalThemeSpaceHomeOverrideQuery($themeAddonKey:String$themeModuleKey:String$spaceKey:String!$spaceHomePageId:String!)@experimental{experimentalThemeSpaceHomeOverride(themeAddonKey:$themeAddonKey themeModuleKey:$themeModuleKey spaceKey:$spaceKey spaceHomePageId:$spaceHomePageId){hasSpaceHomeOverride spaceHomeOverrideDescriptor{addon_key apiMigrations{gdpr}contentClassifier contextJwt cp general h hostOrigin key moduleType origin productCtx sandbox structuredContext timeZone uniqueKey url w}}}`;

});


parcelRegister("4b4iP", function(module, exports) {

$parcel$export(module.exports, "SpaceRestrictionHandler", () => $343989ced147f5e6$export$20a459334853e190);

var $gwFzn = parcelRequire("gwFzn");

var $67Foi = parcelRequire("67Foi");

var $hPAXP = parcelRequire("hPAXP");

var $fG32j = parcelRequire("fG32j");

var $aZfd8 = parcelRequire("aZfd8");
const $343989ced147f5e6$export$20a459334853e190 = ({ children: children, spaceKey: spaceKey, isAnonymous: isAnonymous = false, contentId: contentId, isFirstRoute: isFirstRoute = false, goBackPreviousPage: goBackPreviousPage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fG32j.SpaceRestrictionCheck), {
        spaceKey: spaceKey
    }, ({ isSpaceRestricted: isSpaceRestricted, isSpaceNotFound: isSpaceNotFound })=>{
        if (isSpaceRestricted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hPAXP.RestrictedSpace), {
            goToPreviousPage: goBackPreviousPage,
            isFirstRoute: isFirstRoute,
            contentId: contentId
        });
        if (isSpaceNotFound && !isAnonymous && !contentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aZfd8.Space404), {
            goBackPreviousPage: goBackPreviousPage,
            isFirstRoute: isFirstRoute
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $67Foi.ScreenEvent), {
            name: "spaceNotFoundScreen",
            id: spaceKey
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
    });
};

});
parcelRegister("aZfd8", function(module, exports) {

$parcel$export(module.exports, "Space404", () => $c70a78199cd90f84$export$a506b89ee82dfeb8);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $gllul = parcelRequire("gllul");
const $c70a78199cd90f84$export$a506b89ee82dfeb8 = (props)=>{
    const { isFirstRoute: isFirstRoute, goBackPreviousPage: goBackPreviousPage } = props;
    const onClickGoPreviousLink = (e)=>{
        e.preventDefault();
        if (goBackPreviousPage) goBackPreviousPage();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gllul.NotFound), {
        secondaryButtonProps: {
            children: !isFirstRoute && goBackPreviousPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                id: "space-404.text.go.back.previous.page",
                defaultMessage: "Go to previous page"
            }),
            onClick: onClickGoPreviousLink
        }
    });
};
$c70a78199cd90f84$export$a506b89ee82dfeb8.displayName = 'Space404';

});


parcelRegister("j9XVO", function(module, exports) {

$parcel$export(module.exports, "useSpaceBaseQuery", () => $2278a3c3763ebfe6$export$8eab19bcc4a0311d);

var $d2LG0 = parcelRequire("d2LG0");

var $diswb = parcelRequire("diswb");

var $6mKj3 = parcelRequire("6mKj3");

var $lumgz = parcelRequire("lumgz");
const $2278a3c3763ebfe6$export$a45766b8588918d2 = (0, $d2LG0.default)`query useSpaceBaseQuerySpaceQuery($spaceKey:String){space(key:$spaceKey){id key name alias}}`;
const $2278a3c3763ebfe6$export$8eab19bcc4a0311d = ({ resolvedSpaceKey: resolvedSpaceKey })=>{
    const { data: spaceBaseQueryData, loading: spaceBaseQueryLoading, error: spaceBaseQueryError } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $lumgz.spaceForBaseSpaceQuery), {
        skip: // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        Boolean(undefined) || (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false),
        variables: {
            spaceKey: resolvedSpaceKey
        }
    });
    const { data: singleSpaceQueryData, loading: singleSpaceQueryLoading, error: singleSpaceQueryError } = (0, $diswb.useQuery)($2278a3c3763ebfe6$export$a45766b8588918d2, {
        skip: // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        Boolean(undefined) || !(0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false),
        variables: {
            spaceKey: resolvedSpaceKey
        }
    });
    let space, loading;
    if ((0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false)) {
        loading = singleSpaceQueryLoading;
        space = singleSpaceQueryError && !singleSpaceQueryLoading ? null : singleSpaceQueryData?.space;
    } else {
        loading = spaceBaseQueryLoading;
        space = spaceBaseQueryError && !spaceBaseQueryLoading ? null : spaceBaseQueryData?.spaces?.nodes?.[0];
    }
    return {
        space: space,
        loading: loading
    };
};

});


parcelRegister("iqZzD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6ba6afbc5717c4a$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $iqPBi = parcelRequire("iqPBi");
var $d6ba6afbc5717c4a$export$2e2bcd8739ae039 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqPBi.SpaceBase), props);
};

});

parcelRegister("f5aR2", function(module, exports) {

$parcel$export(module.exports, "ContentExtensionsProvider", () => $cc34c55db5a1bcbb$export$2a88d3b468decd4a);

var $gwFzn = parcelRequire("gwFzn");

var $7okiz = parcelRequire("7okiz");

var $69aHU = parcelRequire("69aHU");

var $hMRhJ = parcelRequire("hMRhJ");

var $jFmKg = parcelRequire("jFmKg");

const $cc34c55db5a1bcbb$var$getLegacyContentExtensions = ()=>({
        loadSortableTable: ()=>(parcelRequire("ksEBw"))
    });
const $cc34c55db5a1bcbb$var$providers = {
    getExtensionHandlers: $7okiz.getExtensionHandlers,
    getLegacyContentExtensions: $cc34c55db5a1bcbb$var$getLegacyContentExtensions,
    populateExtensionProviders: $69aHU.populateExtensionProviders,
    EditorLoaderLoader: $jFmKg.default
};
const $cc34c55db5a1bcbb$export$2a88d3b468decd4a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hMRhJ.RendererExtensionContext).Provider, {
        value: $cc34c55db5a1bcbb$var$providers
    }, children);

});
parcelRegister("ksEBw", function(module, exports) {

let $ee55eb4c4f13c236$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ee55eb4c4f13c236$var$load("kuPgl").then(()=>parcelRequire('5byen'));

});


parcelRegister("4H46k", function(module, exports) {

$parcel$export(module.exports, "LazySpaceBlogRedirect", () => $36ae5bfcf92491af$export$2f32c75fff716fcc);
$parcel$export(module.exports, "LazySpaceEditPage", () => $36ae5bfcf92491af$export$d7b87d306b5def2c);
$parcel$export(module.exports, "LazySpaceCreatePage", () => $36ae5bfcf92491af$export$5590c410e7d0a293);
$parcel$export(module.exports, "LazyRouteToRightEditor", () => $36ae5bfcf92491af$export$325f108b642b51d);
$parcel$export(module.exports, "LazyMobileWebContainer", () => $36ae5bfcf92491af$export$e650af616d3a92cf);
$parcel$export(module.exports, "LazyDwellTime", () => $36ae5bfcf92491af$export$dcf40c4d983a3b1f);
$parcel$export(module.exports, "LazyConsumptionViewedAndCompletedEventTracker", () => $36ae5bfcf92491af$export$a804be9097757ef8);
$parcel$export(module.exports, "LazyConfluenceNotFound", () => $36ae5bfcf92491af$export$33256e23669f7955);
$parcel$export(module.exports, "LazyTeamCalendars", () => $36ae5bfcf92491af$export$666c7163d0ae1b3f);
$parcel$export(module.exports, "LazyQuestions", () => $36ae5bfcf92491af$export$aeb070a9ba92094e);
$parcel$export(module.exports, "LazyJiraProjectBoard", () => $36ae5bfcf92491af$export$b91db2a8ae520395);
// These exports are using the .default prop of the module because we're mixing ES6 and ES5. This is required for
// webpack to be able to correctly split bundles.

var $jmjWc = parcelRequire("jmjWc");

const $36ae5bfcf92491af$export$2f32c75fff716fcc = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "b7m6n",
    name: "LazySpaceBlogRedirect",
    loader: async ()=>(await (parcelRequire("ffqoj"))).SpaceBlogRedirect
});

const $36ae5bfcf92491af$export$d7b87d306b5def2c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "z-U-s",
    name: "LazySpaceEditPage",
    loader: ()=>(parcelRequire("jqU3k"))
});

const $36ae5bfcf92491af$export$5590c410e7d0a293 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LfHUf",
    name: "LazySpaceCreatePage",
    loader: ()=>(parcelRequire("2DkC7"))
});

const $36ae5bfcf92491af$export$325f108b642b51d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "91GWy",
    name: "LazyRouteToRightEditor",
    loader: ()=>(parcelRequire("3gswZ"))
});

const $36ae5bfcf92491af$export$e650af616d3a92cf = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Z1eTA",
    name: "LazyMobileWebContainer",
    loader: ()=>(parcelRequire("4HG2K"))
});

const $36ae5bfcf92491af$export$dcf40c4d983a3b1f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "TnNDX",
    name: "LazyDwellTime",
    loader: ()=>(parcelRequire("imuhR"))
});

const $36ae5bfcf92491af$export$a804be9097757ef8 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "GCYkT",
    name: "LazyConsumptionViewedAndCompletedEventTracker",
    loader: async ()=>(await (parcelRequire("6bmvl"))).ConsumptionViewedAndCompletedEventTracker
});

const $36ae5bfcf92491af$export$33256e23669f7955 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AaHry",
    name: "LazyConfluenceNotFound",
    loader: ()=>(parcelRequire("4n6Pr"))
});

const $36ae5bfcf92491af$export$666c7163d0ae1b3f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ZAbLZ",
    name: "LazyTeamCalendars",
    loader: async ()=>(await (parcelRequire("kea7h"))).TeamCalendar
});

const $36ae5bfcf92491af$export$aeb070a9ba92094e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "YG4Pa",
    name: "LazyQuestions",
    loader: async ()=>(await (parcelRequire("4IFhp"))).Questions
});

const $36ae5bfcf92491af$export$b91db2a8ae520395 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "IIGIO",
    name: "LazyJiraProjectBoard",
    loader: async ()=>(await (parcelRequire("iKaWy"))).JiraProjectBoard
});

});
parcelRegister("ffqoj", function(module, exports) {

let $b19cba74273d2c26$var$load = (parcelRequire("lhnSv"))(5);



module.exports = Promise.all([
    (parcelRequire("di5rn"))((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve("1PDLq"), 5)),
    $b19cba74273d2c26$var$load("dqnQo")
]).then(()=>parcelRequire('iT775'));

});
parcelRegister("di5rn", function(module, exports) {
"use strict";

var $jDpSy = parcelRequire("jDpSy");
module.exports = $jDpSy(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("jDpSy", function(module, exports) {
"use strict";
let $e4b5bbdb98dce921$var$cachedBundles = {};
let $e4b5bbdb98dce921$var$cachedPreloads = {};
let $e4b5bbdb98dce921$var$cachedPrefetches = {};
function $e4b5bbdb98dce921$var$getCache(type) {
    switch(type){
        case 'preload':
            return $e4b5bbdb98dce921$var$cachedPreloads;
        case 'prefetch':
            return $e4b5bbdb98dce921$var$cachedPrefetches;
        default:
            return $e4b5bbdb98dce921$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        let cache = $e4b5bbdb98dce921$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("jqU3k", function(module, exports) {

let $e25becf294d2393e$var$load = (parcelRequire("lhnSv"))(5);



module.exports = Promise.all([
    (parcelRequire("di5rn"))((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve("73iD8"), 5)),
    $e25becf294d2393e$var$load("9uNix"),
    $e25becf294d2393e$var$load("lMmk5"),
    $e25becf294d2393e$var$load("dA1E5"),
    $e25becf294d2393e$var$load("hz56j"),
    $e25becf294d2393e$var$load("dSrBl"),
    $e25becf294d2393e$var$load("43hsF"),
    $e25becf294d2393e$var$load("i27dG"),
    $e25becf294d2393e$var$load("jycv9"),
    $e25becf294d2393e$var$load("2Qrvo"),
    $e25becf294d2393e$var$load("iFwd1")
]).then(()=>parcelRequire('hyHUM'));

});

parcelRegister("2DkC7", function(module, exports) {

let $1eaf36c26dd6b88e$var$load = (parcelRequire("lhnSv"))(5);



module.exports = Promise.all([
    $1eaf36c26dd6b88e$var$load("9uNix"),
    (parcelRequire("di5rn"))((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve("6Owk1"), 5)),
    $1eaf36c26dd6b88e$var$load("lMmk5"),
    $1eaf36c26dd6b88e$var$load("dA1E5"),
    $1eaf36c26dd6b88e$var$load("hz56j"),
    $1eaf36c26dd6b88e$var$load("dSrBl"),
    $1eaf36c26dd6b88e$var$load("43hsF"),
    $1eaf36c26dd6b88e$var$load("i27dG"),
    $1eaf36c26dd6b88e$var$load("jycv9"),
    $1eaf36c26dd6b88e$var$load("2Qrvo"),
    $1eaf36c26dd6b88e$var$load("2xeoE")
]).then(()=>parcelRequire('3ajXc'));

});

parcelRegister("3gswZ", function(module, exports) {

let $2608ff6564c64f3b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2608ff6564c64f3b$var$load("5oUQI").then(()=>parcelRequire('lx9c3'));

});

parcelRegister("4HG2K", function(module, exports) {

let $36cbca7d3af41fdb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $36cbca7d3af41fdb$var$load("jycv9"),
    $36cbca7d3af41fdb$var$load("XfwMA")
]).then(()=>parcelRequire('hKxxO'));

});

parcelRegister("imuhR", function(module, exports) {

let $d5e1c66f0e3bc70b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d5e1c66f0e3bc70b$var$load("3g3yi").then(()=>parcelRequire('bBPzK'));

});

parcelRegister("6bmvl", function(module, exports) {

let $48053a1b96584493$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $48053a1b96584493$var$load("fvv3N").then(()=>parcelRequire('11i6T'));

});

parcelRegister("4n6Pr", function(module, exports) {

let $32ee9b77e9f476b5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $32ee9b77e9f476b5$var$load("jycv9").then(()=>parcelRequire('hxzAh'));

});

parcelRegister("kea7h", function(module, exports) {

let $eb9cf6572e7f40d7$var$load = (parcelRequire("lhnSv"))(5);



module.exports = Promise.all([
    $eb9cf6572e7f40d7$var$load("dH2J7"),
    $eb9cf6572e7f40d7$var$load("dVstB"),
    $eb9cf6572e7f40d7$var$load("4hc06"),
    (parcelRequire("di5rn"))((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve("3g2Oe"), 5)),
    $eb9cf6572e7f40d7$var$load("5oU5X"),
    $eb9cf6572e7f40d7$var$load("5B8F6"),
    $eb9cf6572e7f40d7$var$load("2tDVK"),
    $eb9cf6572e7f40d7$var$load("ftJgg"),
    $eb9cf6572e7f40d7$var$load("cO75g"),
    $eb9cf6572e7f40d7$var$load("gLxW3"),
    $eb9cf6572e7f40d7$var$load("6qah4"),
    $eb9cf6572e7f40d7$var$load("buSZn")
]).then(()=>parcelRequire('2ZK7m'));

});

parcelRegister("4IFhp", function(module, exports) {

let $36fb4acc41791a68$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $36fb4acc41791a68$var$load("jXE7i"),
    $36fb4acc41791a68$var$load("iLLJH"),
    $36fb4acc41791a68$var$load("iAspJ"),
    $36fb4acc41791a68$var$load("emd3r"),
    $36fb4acc41791a68$var$load("grG1M"),
    $36fb4acc41791a68$var$load("7KMgV"),
    $36fb4acc41791a68$var$load("dTsOE"),
    $36fb4acc41791a68$var$load("acQiP"),
    $36fb4acc41791a68$var$load("hlqS1"),
    $36fb4acc41791a68$var$load("l42ar"),
    $36fb4acc41791a68$var$load("fKONs"),
    $36fb4acc41791a68$var$load("j2OLf"),
    $36fb4acc41791a68$var$load("f28kH"),
    $36fb4acc41791a68$var$load("cMkgU"),
    $36fb4acc41791a68$var$load("47wm8"),
    $36fb4acc41791a68$var$load("dzfxi"),
    $36fb4acc41791a68$var$load("7OtNC"),
    $36fb4acc41791a68$var$load("k6H7B"),
    $36fb4acc41791a68$var$load("4x0L6"),
    $36fb4acc41791a68$var$load("7jSfd"),
    $36fb4acc41791a68$var$load("4HZlX"),
    $36fb4acc41791a68$var$load("kDqHr"),
    $36fb4acc41791a68$var$load("5SiDe"),
    $36fb4acc41791a68$var$load("c6MKV"),
    $36fb4acc41791a68$var$load("ibBUd"),
    $36fb4acc41791a68$var$load("6qah4"),
    $36fb4acc41791a68$var$load("aZinD"),
    $36fb4acc41791a68$var$load("dVstB"),
    $36fb4acc41791a68$var$load("56uR7"),
    $36fb4acc41791a68$var$load("4GuoO")
]).then(()=>parcelRequire('a6Tu8'));

});

parcelRegister("iKaWy", function(module, exports) {

let $da5503082ba49fd9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $da5503082ba49fd9$var$load("ej4rO"),
    $da5503082ba49fd9$var$load("2w2Fa"),
    $da5503082ba49fd9$var$load("9QvHa"),
    $da5503082ba49fd9$var$load("3ooAX"),
    $da5503082ba49fd9$var$load("4lfDj"),
    $da5503082ba49fd9$var$load("kUAIU"),
    $da5503082ba49fd9$var$load("dTsOE"),
    $da5503082ba49fd9$var$load("5SiDe"),
    $da5503082ba49fd9$var$load("hRUJD")
]).then(()=>parcelRequire('dYnWI'));

});


parcelRegister("6Evf5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d7eb68e35a8590f$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $diswb = parcelRequire("diswb");

var $ep3mz = parcelRequire("ep3mz");

var $hl1Kw = parcelRequire("hl1Kw");

var $3GP6F = parcelRequire("3GP6F");

var $9LzHv = parcelRequire("9LzHv");

var $iAoZQ = parcelRequire("iAoZQ");
const $4d7eb68e35a8590f$var$dayInMilliseconds = 86400000; // hours*minutes*seconds*milliseconds
const $4d7eb68e35a8590f$var$NO_DATE_DEFINED = -1;
const $4d7eb68e35a8590f$var$ARCHIVED = 'archived';
const $4d7eb68e35a8590f$export$10ab27af88aafb56 = (pastDateStr, currentDate = new Date())=>{
    const pastDate = new Date(pastDateStr);
    // days since creation
    return Math.round((currentDate.getTime() - pastDate.getTime()) / $4d7eb68e35a8590f$var$dayInMilliseconds);
};
const $4d7eb68e35a8590f$var$_getDaysSinceCreated = (node)=>{
    const createdDateStr = node?.history?.createdDate;
    return createdDateStr ? $4d7eb68e35a8590f$export$10ab27af88aafb56(createdDateStr) : $4d7eb68e35a8590f$var$NO_DATE_DEFINED;
};
const $4d7eb68e35a8590f$var$_getDaysSinceUpdated = (node)=>{
    const lastUpdatedStr = node?.history?.lastUpdated?.when;
    return lastUpdatedStr ? $4d7eb68e35a8590f$export$10ab27af88aafb56(lastUpdatedStr) : $4d7eb68e35a8590f$var$NO_DATE_DEFINED;
};
const $4d7eb68e35a8590f$export$f8668f0d8d89d19c = (currentDate = new Date())=>{
    const hours = currentDate.getHours();
    return hours >= 15 && hours <= 23;
};
const $4d7eb68e35a8590f$export$35de754c0b3b58bd = ()=>{
    if (document && document.visibilityState) return document.visibilityState;
    return 'unset';
};
const $4d7eb68e35a8590f$var$SendTrackViewPageEvent = ({ pageType: pageType, source: source })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [{ searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics }] = (0, $hl1Kw.useSearchSessionId)();
    const featureCodes = (0, $3GP6F.useFeatureCodesInURL)();
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)((0, $iAoZQ.SendTrackViewPageEventQuery), {
        variables: {
            contentId: contentId
        }
    });
    const space = data?.content?.nodes?.[0]?.space;
    const fabricEditorSupported = data?.content?.nodes?.[0]?.metadata?.frontend?.fabricEditorSupported;
    const fabricEditorEligibility = data?.content?.nodes?.[0]?.metadata?.frontend?.fabricEditorEligibility;
    if (error || loading || !space) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9LzHv.default), {
        action: "viewed",
        actionSubject: "page",
        source: source,
        containerType: "space",
        containerId: space.id,
        objectType: "page",
        objectId: contentId,
        attributes: {
            pageType: pageType,
            daysSinceCreated: $4d7eb68e35a8590f$var$_getDaysSinceCreated(data.content.nodes[0]),
            daysSinceModified: $4d7eb68e35a8590f$var$_getDaysSinceUpdated(data.content.nodes[0]),
            searchReferrer: searchSessionId,
            ...additionalAnalytics,
            isArchivedPage: data.content.nodes[0].status === $4d7eb68e35a8590f$var$ARCHIVED,
            viewedScreenAfter3PM: $4d7eb68e35a8590f$export$f8668f0d8d89d19c(),
            pageVisibility: $4d7eb68e35a8590f$export$35de754c0b3b58bd(),
            fabricEditorEligibility: fabricEditorEligibility,
            fabricEditorSupported: fabricEditorSupported,
            ...featureCodes && featureCodes.from ? {
                from: featureCodes.from
            } : {}
        }
    });
};
$4d7eb68e35a8590f$var$SendTrackViewPageEvent.propTypes = {
    pageType: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).oneOf([
        'page',
        'blogpost'
    ]),
    source: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).oneOf([
        'viewPageScreen',
        'mobileWebView'
    ])
};
$4d7eb68e35a8590f$var$SendTrackViewPageEvent.defaultProps = {
    source: 'viewPageScreen'
};
var $4d7eb68e35a8590f$export$2e2bcd8739ae039 = $4d7eb68e35a8590f$var$SendTrackViewPageEvent;

});
parcelRegister("9LzHv", function(module, exports) {

$parcel$export(module.exports, "default", () => $71c43243f3d11279$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $1DWH0 = parcelRequire("1DWH0");
const $71c43243f3d11279$var$sendTrackEvent = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const analyticsData = {
        action: props.action,
        actionSubject: props.actionSubject,
        attributes: props.attributes,
        containerId: props.containerId,
        containerType: props.containerType,
        objectId: props.objectId,
        objectType: props.objectType,
        source: props.source
    };
    const analyticsEvent = createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: analyticsData
    });
    analyticsEvent.fire();
};
function $71c43243f3d11279$var$SendTrackEventComponent(props) {
    const { action: action, actionSubject: actionSubject, attributes: attributes, containerId: containerId, containerType: containerType, objectId: objectId, objectType: objectType, source: source } = props;
    (0, $gwFzn.useEffect)(()=>{
        $71c43243f3d11279$var$sendTrackEvent(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        action,
        actionSubject,
        attributes,
        containerId,
        containerType,
        objectId,
        objectType,
        source
    ]);
    return null;
}
$71c43243f3d11279$var$SendTrackEventComponent.propTypes = {
    action: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    actionSubject: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object,
    containerId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    containerType: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    objectId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    objectType: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    source: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    createAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired
};
$71c43243f3d11279$var$SendTrackEventComponent.defaultProps = {
    attributes: {}
};
var $71c43243f3d11279$export$2e2bcd8739ae039 = (0, $1DWH0.default)()($71c43243f3d11279$var$SendTrackEventComponent);

});

parcelRegister("iAoZQ", function(module, exports) {

$parcel$export(module.exports, "SendTrackViewPageEventQuery", () => $d87efa95de2d7c4b$export$891b2cd76733e577);

var $d2LG0 = parcelRequire("d2LG0");
const $d87efa95de2d7c4b$export$891b2cd76733e577 = (0, $d2LG0.default)`query SendTrackViewPageEventQuery($contentId:ID){content(id:$contentId){nodes{id history{createdDate lastUpdated{when}}metadata{frontend{fabricEditorSupported fabricEditorEligibility}}space{id}status}}}`;

});


parcelRegister("480xA", function(module, exports) {

$parcel$export(module.exports, "EmbeddedViewPageLoader", () => $d81ad828f72fdf38$export$3717da370a5be6bc);
$parcel$export(module.exports, "EmbeddedEditPageLoader", () => $d81ad828f72fdf38$export$a835caedc175b18);
$parcel$export(module.exports, "EmbeddedWhiteboardLoader", () => $d81ad828f72fdf38$export$eaeb91b7cf6d3df6);

var $jmjWc = parcelRequire("jmjWc");

const $d81ad828f72fdf38$export$3717da370a5be6bc = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "jHvmi",
    name: "EmbeddedViewPageLoader",
    loader: async ()=>(await (parcelRequire("3IiS0"))).EmbeddedViewPage
});

const $d81ad828f72fdf38$export$a835caedc175b18 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "BMGOy",
    name: "EmbeddedEditPageLoader",
    loader: async ()=>(await (parcelRequire("aIte2"))).EmbeddedEditPage
});

const $d81ad828f72fdf38$export$eaeb91b7cf6d3df6 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "wHmJ5",
    name: "EmbeddedWhiteboardLoader",
    loader: async ()=>(await (parcelRequire("Zp0kn"))).EmbeddedWhiteboard
});

});
parcelRegister("3IiS0", function(module, exports) {

let $2b441e5f665e4d00$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $2b441e5f665e4d00$var$load("56uR7"),
    $2b441e5f665e4d00$var$load("7jBYv"),
    $2b441e5f665e4d00$var$load("i3TSs"),
    $2b441e5f665e4d00$var$load("affRy"),
    $2b441e5f665e4d00$var$load("2u53D"),
    $2b441e5f665e4d00$var$load("hRj6h"),
    $2b441e5f665e4d00$var$load("cO75g"),
    $2b441e5f665e4d00$var$load("daCl8"),
    $2b441e5f665e4d00$var$load("emd3r"),
    $2b441e5f665e4d00$var$load("gzLQS"),
    $2b441e5f665e4d00$var$load("bPq1i"),
    $2b441e5f665e4d00$var$load("ePOyH"),
    $2b441e5f665e4d00$var$load("7YFVd"),
    $2b441e5f665e4d00$var$load("dH2J7"),
    $2b441e5f665e4d00$var$load("l1QPP"),
    $2b441e5f665e4d00$var$load("dTsOE"),
    $2b441e5f665e4d00$var$load("5SiDe"),
    $2b441e5f665e4d00$var$load("c6MKV"),
    $2b441e5f665e4d00$var$load("ibBUd"),
    $2b441e5f665e4d00$var$load("6qah4"),
    $2b441e5f665e4d00$var$load("aZinD"),
    $2b441e5f665e4d00$var$load("dVstB"),
    $2b441e5f665e4d00$var$load("i5jQN"),
    $2b441e5f665e4d00$var$load("dX2je"),
    $2b441e5f665e4d00$var$load("c4YL4"),
    $2b441e5f665e4d00$var$load("lou39"),
    $2b441e5f665e4d00$var$load("jXE7i"),
    $2b441e5f665e4d00$var$load("2Qrvo"),
    $2b441e5f665e4d00$var$load("dSrBl"),
    $2b441e5f665e4d00$var$load("9uNix"),
    $2b441e5f665e4d00$var$load("4hc06"),
    $2b441e5f665e4d00$var$load("WXYxI")
]).then(()=>parcelRequire('6N2H2'));

});

parcelRegister("aIte2", function(module, exports) {

let $7cd4aefaecfe45b9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $7cd4aefaecfe45b9$var$load("7YFVd"),
    $7cd4aefaecfe45b9$var$load("dSrBl"),
    $7cd4aefaecfe45b9$var$load("9ECxk"),
    $7cd4aefaecfe45b9$var$load("iAspJ"),
    $7cd4aefaecfe45b9$var$load("jCu7l"),
    $7cd4aefaecfe45b9$var$load("5zDuS"),
    $7cd4aefaecfe45b9$var$load("emd3r"),
    $7cd4aefaecfe45b9$var$load("4gtMV"),
    $7cd4aefaecfe45b9$var$load("hMDX9"),
    $7cd4aefaecfe45b9$var$load("7KMgV"),
    $7cd4aefaecfe45b9$var$load("5SiDe"),
    $7cd4aefaecfe45b9$var$load("c6MKV"),
    $7cd4aefaecfe45b9$var$load("ibBUd"),
    $7cd4aefaecfe45b9$var$load("6qah4"),
    $7cd4aefaecfe45b9$var$load("aZinD"),
    $7cd4aefaecfe45b9$var$load("eMlc0"),
    $7cd4aefaecfe45b9$var$load("dVstB"),
    $7cd4aefaecfe45b9$var$load("1Uega"),
    $7cd4aefaecfe45b9$var$load("56uR7"),
    $7cd4aefaecfe45b9$var$load("jXE7i"),
    $7cd4aefaecfe45b9$var$load("9uNix"),
    $7cd4aefaecfe45b9$var$load("aHCaB"),
    $7cd4aefaecfe45b9$var$load("gzLQS"),
    $7cd4aefaecfe45b9$var$load("3vBXj"),
    $7cd4aefaecfe45b9$var$load("3Ha0P"),
    $7cd4aefaecfe45b9$var$load("dH2J7"),
    $7cd4aefaecfe45b9$var$load("c4YL4"),
    $7cd4aefaecfe45b9$var$load("lou39"),
    $7cd4aefaecfe45b9$var$load("3Kg3S"),
    $7cd4aefaecfe45b9$var$load("i0gb6"),
    $7cd4aefaecfe45b9$var$load("g7QTt"),
    $7cd4aefaecfe45b9$var$load("lwNze")
]).then(()=>parcelRequire('dJsyi'));

});

parcelRegister("Zp0kn", function(module, exports) {

let $0b8917f317f63f06$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $0b8917f317f63f06$var$load("9uNix"),
    $0b8917f317f63f06$var$load("1Zo7q"),
    $0b8917f317f63f06$var$load("eI3Gm"),
    $0b8917f317f63f06$var$load("i3TSs"),
    $0b8917f317f63f06$var$load("affRy"),
    $0b8917f317f63f06$var$load("i5Fj1"),
    $0b8917f317f63f06$var$load("2u53D"),
    $0b8917f317f63f06$var$load("dLkMK"),
    $0b8917f317f63f06$var$load("hRj6h"),
    $0b8917f317f63f06$var$load("daCl8"),
    $0b8917f317f63f06$var$load("leIbB"),
    $0b8917f317f63f06$var$load("emd3r"),
    $0b8917f317f63f06$var$load("gzLQS"),
    $0b8917f317f63f06$var$load("bPq1i"),
    $0b8917f317f63f06$var$load("ePOyH"),
    $0b8917f317f63f06$var$load("7YFVd"),
    $0b8917f317f63f06$var$load("dH2J7"),
    $0b8917f317f63f06$var$load("l1QPP"),
    $0b8917f317f63f06$var$load("dTsOE"),
    $0b8917f317f63f06$var$load("5SiDe"),
    $0b8917f317f63f06$var$load("c6MKV"),
    $0b8917f317f63f06$var$load("ibBUd"),
    $0b8917f317f63f06$var$load("6qah4"),
    $0b8917f317f63f06$var$load("aZinD"),
    $0b8917f317f63f06$var$load("dVstB"),
    $0b8917f317f63f06$var$load("6oPQN"),
    $0b8917f317f63f06$var$load("2YtNo"),
    $0b8917f317f63f06$var$load("i5jQN"),
    $0b8917f317f63f06$var$load("dX2je"),
    $0b8917f317f63f06$var$load("c4YL4"),
    $0b8917f317f63f06$var$load("lou39"),
    $0b8917f317f63f06$var$load("4hc06"),
    $0b8917f317f63f06$var$load("le4u8")
]).then(()=>parcelRequire('gG2kN'));

});


parcelRegister("9pOEz", function(module, exports) {

$parcel$export(module.exports, "CommentContextWrapper", () => $1adfb96e71037064$export$1d04f0e8aa57d594);

var $gwFzn = parcelRequire("gwFzn");

var $9jl6v = parcelRequire("9jl6v");
const $1adfb96e71037064$export$1d04f0e8aa57d594 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9jl6v.InlineCommentsProvider), null, children);
};

});

parcelRegister("34NZw", function(module, exports) {

$parcel$export(module.exports, "PageShownPublicLinksEventLoader", () => $d52b69b4dbbb4bb4$export$e6747c633274762a);

var $jmjWc = parcelRequire("jmjWc");

const $d52b69b4dbbb4bb4$export$e6747c633274762a = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "UL-jW",
    name: "PageShownPublicLinksEventLoader",
    loader: async ()=>{
        const { PageShownPublicLinksEvent: PageShownPublicLinksEvent } = await (parcelRequire("5pl9w"));
        return PageShownPublicLinksEvent;
    }
});

});
parcelRegister("5pl9w", function(module, exports) {

let $3effb20336e05422$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3effb20336e05422$var$load("63zHi").then(()=>parcelRequire('jvel0'));

});


parcelRegister("f1JyU", function(module, exports) {

$parcel$export(module.exports, "CommentsSectionLoader", () => (parcelRequire("6kENE")).CommentsSectionLoader);
// @ts-ignore

var $6kENE = parcelRequire("6kENE");

});
parcelRegister("6kENE", function(module, exports) {

$parcel$export(module.exports, "CommentsSectionLoader", () => $49c4425738104f21$export$2fa3aacacd7711f1);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $hnvzE = parcelRequire("hnvzE");

var $eHtji = parcelRequire("eHtji");
var $7d2Nc = parcelRequire("7d2Nc");

var $jmjWc = parcelRequire("jmjWc");

var $deTj5 = parcelRequire("deTj5");

var $6Hogt = parcelRequire("6Hogt");

var $2YUV8 = parcelRequire("2YUV8");
var $dDqLo = parcelRequire("dDqLo");

var $3Am3T = parcelRequire("3Am3T");

var $bQm3c = parcelRequire("bQm3c");

var $dkkKv = parcelRequire("dkkKv");
var $7Oxky = parcelRequire("7Oxky");
var $8i27m = parcelRequire("8i27m");

var $9wGTI = parcelRequire("9wGTI");

const $49c4425738104f21$export$a378d01c696bd81e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "RIvcu",
    name: "CommentsSectionFabric",
    // eslint-disable-next-line react/prop-types
    //@ts-ignore
    loading: ({ handlePageCommentsRender: handlePageCommentsRender })=>{
        return !handlePageCommentsRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $deTj5.CommentPlaceholder), null) : null;
    },
    loader: ()=>//@ts-ignore
        (parcelRequire("799zh"))
});

const $49c4425738104f21$export$4740f0dffd11e693 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "WGE8D",
    name: "CommentsSectionFabricPaint",
    loader: ()=>//@ts-ignore
        (parcelRequire("799zh"))
});
const $49c4425738104f21$export$2fa3aacacd7711f1 = ({ contentId: contentId, ...props })=>{
    // This information is available in the CommentsCountContext, but it also needs to be available to the legacy class
    // component so passing in directly from the hook as well
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $dDqLo.useCommentCounts)(contentId);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const allowNestedComments = (0, $2YUV8.useAllowNestedComments)();
    const commentsDataActions = (0, $8i27m.useCommentsDataActions)();
    const { refetch: refetchActiveComments } = (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId
    });
    const { refetch: refetchActiveInlineComments } = (0, $7Oxky.useActiveInlineCommentsQuery)({
        pageId: contentId,
        markerRefList: []
    });
    return(// @ts-ignore
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hnvzE.default), {
        name: "page-comments"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        key: props.contentId,
        metric: (0, $6Hogt.PAGE_COMMENTS_METRIC),
        isCustomStart: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eHtji.PageSegmentLoadMark), {
        markName: "pageCommentsRenderStart",
        metric: (0, $6Hogt.PAGE_COMMENTS_METRIC)
    }), (0, $9wGTI.fg)('confluence_frontend_remove_comments_placeholder') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($49c4425738104f21$export$4740f0dffd11e693, {
        ...props,
        // @ts-ignore
        contentId: contentId,
        inlineCommentsCount: unresolvedInlineCommentsCount,
        cloudId: cloudId,
        allowNestedComments: allowNestedComments,
        commentsDataActions: commentsDataActions,
        refetchCommentsPanel: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? refetchActiveComments : refetchActiveInlineComments
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($49c4425738104f21$export$a378d01c696bd81e, {
        ...props,
        // @ts-ignore
        contentId: contentId,
        inlineCommentsCount: unresolvedInlineCommentsCount,
        cloudId: cloudId,
        allowNestedComments: allowNestedComments,
        commentsDataActions: commentsDataActions,
        refetchCommentsPanel: (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') ? refetchActiveComments : refetchActiveInlineComments
    }))));
};
$49c4425738104f21$export$2fa3aacacd7711f1.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired
};

});
parcelRegister("deTj5", function(module, exports) {

$parcel$export(module.exports, "CommentPlaceholder", () => $c27f350b69a05b43$export$46096a93b7c122b2);
/* CommentPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$FlexComment = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1n261g80",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$CommentContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _i0dl1osq _otyru2gc",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Circle = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1ssb _bfhkn82g _1bsbzwfg _4t3izwfg _19pk1b66 _2hwxutpp",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$BeforeStylesContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_n7zlzgxb _1sb2f705 _1e0c1ule _otyrpxbi _ca0qutpp _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$commentWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.250',
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c27f350b69a05b43$var$CommentAddPromptContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19itglyw _2rko1l7b _1bsb1osq _4t3i1ylp _syaz131l _ca0qze3t _1e0c1o8l _s7n4jp4b _18u0u2gc _16jlkb7n _bfhkn82g",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$GridContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c11p5 _yv0ehpgh _727q19bv _bfhk18uv _1bsbdgin _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$Author = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_nd5lzmlf _1yt45uws _19itglyw _2rko1l7b _bfhkn82g _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$var$InnerComment = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_nd5lbahz _1yt41h4g _19itglyw _2rko1l7b _bfhkn82g _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $c27f350b69a05b43$export$46096a93b7c122b2 = ({ showPlaceholder: showPlaceholder = false })=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if ((0, window.__SSR_RENDERED__) || showPlaceholder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $c27f350b69a05b43$var$commentWrapperStyles,
        "data-vc": "comment-placeholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c27f350b69a05b43$var$GridContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c27f350b69a05b43$var$Author, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c27f350b69a05b43$var$InnerComment, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c27f350b69a05b43$var$BeforeStylesContainer, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c27f350b69a05b43$var$FlexComment, {
        "data-testid": "comment-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c27f350b69a05b43$var$CommentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c27f350b69a05b43$var$Circle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c27f350b69a05b43$var$CommentAddPromptContainer, null))));
    else return null;
};

});

parcelRegister("6Hogt", function(module, exports) {

$parcel$export(module.exports, "PAGE_COMMENTS_METRIC", () => $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17);

var $lSOAM = parcelRequire("lSOAM");
var $jX1qB = parcelRequire("jX1qB");
const $8177e5ea6737bcdb$export$a3d0a4d3b44b4a17 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_COMMENTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'pageCommentsRender',
            startMark: 'pageCommentsRenderStart',
            endMark: 'pageCommentsRenderEnd'
        }
    ]
});

});

parcelRegister("2YUV8", function(module, exports) {

$parcel$export(module.exports, "useAllowNestedComments", () => $d2978a0663607f28$export$3044701888c6e050);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $diswb = parcelRequire("diswb");

var $ep3mz = parcelRequire("ep3mz");

var $9wGTI = parcelRequire("9wGTI");

var $aSsfA = parcelRequire("aSsfA");

var $cD1qu = parcelRequire("cD1qu");
const $d2978a0663607f28$var$useAllowNestedCommentsDetailsPanelContentCreatedDateQuery = (0, $d2LG0.default)`query useAllowNestedCommentsDetailsPanelContentCreatedDateQuery($contentId:ID!$status:String!){content(id:$contentId status:[$status]){nodes{id metadata{createdDate}}}}`;
const $d2978a0663607f28$var$NESTED_COMMENTS_LAUNCH_DATE = new Date(Date.UTC(2025, 2, 6)); // 6th March 2025. Only month is 0 indexed.
const $d2978a0663607f28$export$3044701888c6e050 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { data: createdDateData, loading: loading, error: error } = (0, $diswb.useQuery)($d2978a0663607f28$var$useAllowNestedCommentsDetailsPanelContentCreatedDateQuery, {
        variables: {
            contentId: contentId ?? '',
            status: 'current'
        },
        skip: !contentId
    });
    // If the feature flag is not enabled, we should always allow nested comments
    if (!(0, $9wGTI.fg)('confluence_frontend_comments_panel_v2')) return true;
    const pageCreatedDate = createdDateData?.content?.nodes?.[0]?.metadata.createdDate;
    const isLivePage = pageMode === (0, $cD1qu.PageMode).LIVE;
    if (loading || error || !pageCreatedDate) return false;
    const pageCreateDateObject = new Date(pageCreatedDate);
    const isBeforeLaunchDate = pageCreateDateObject < $d2978a0663607f28$var$NESTED_COMMENTS_LAUNCH_DATE;
    return isBeforeLaunchDate && !isLivePage;
};

});

parcelRegister("799zh", function(module, exports) {

let $5340cbaba3ea87ae$var$load = (parcelRequire("lhnSv"))(5);



module.exports = Promise.all([
    $5340cbaba3ea87ae$var$load("7YFVd"),
    $5340cbaba3ea87ae$var$load("hRj6h"),
    $5340cbaba3ea87ae$var$load("lU1wr"),
    $5340cbaba3ea87ae$var$load("29wqP"),
    $5340cbaba3ea87ae$var$load("i5jQN"),
    $5340cbaba3ea87ae$var$load("dX2je"),
    $5340cbaba3ea87ae$var$load("c4YL4"),
    $5340cbaba3ea87ae$var$load("lou39"),
    $5340cbaba3ea87ae$var$load("dSrBl"),
    (parcelRequire("di5rn"))((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve("hpm26"), 5)),
    $5340cbaba3ea87ae$var$load("dPdkf"),
    $5340cbaba3ea87ae$var$load("63hQz"),
    $5340cbaba3ea87ae$var$load("dH2J7"),
    $5340cbaba3ea87ae$var$load("ekztv"),
    $5340cbaba3ea87ae$var$load("3zuUe"),
    $5340cbaba3ea87ae$var$load("ibBUd"),
    $5340cbaba3ea87ae$var$load("6qah4"),
    $5340cbaba3ea87ae$var$load("aZinD"),
    $5340cbaba3ea87ae$var$load("fQeY5")
]).then(()=>parcelRequire('auRw3'));

});




//# sourceMappingURL=ConditionalPublish.6e7758ca.js.map
